import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const BASE = `${config.BASE_URL}/storage-settings`;

async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

export async function getStorageSettings() {
  const res = await authFetch(BASE, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(payload?.message || "Failed to load storage settings");
  }
  return payload;
}

/** Email OTP to ADMIN_EMAIL before switching storage. */
export async function requestStorageChangeMfa(provider) {
  const res = await authFetch(`${BASE}/mfa/request`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(),
    body: JSON.stringify({ provider }),
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(payload?.message || "Failed to send verification OTP");
  }
  return payload;
}

export async function updateStorageSettings(provider, otp) {
  const res = await authFetch(BASE, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(),
    body: JSON.stringify({ provider, otp }),
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(payload?.message || "Failed to update storage settings");
  }
  return payload;
}

export async function updateGeofencingSettings(enabled) {
  const res = await authFetch(`${BASE}/geofencing`, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(),
    body: JSON.stringify({ enabled: Boolean(enabled) }),
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(payload?.message || "Failed to update geofencing settings");
  }
  return payload;
}
